(() => {
  const initialise = (carousel) => {
    if (carousel.dataset.reviewCarouselReady === 'true') return;
    carousel.dataset.reviewCarouselReady = 'true';
    const track = carousel.querySelector('[data-review-track]');
    const cards = [...carousel.querySelectorAll('[data-review-card]')];
    const previous = carousel.querySelector('[data-review-previous]');
    const next = carousel.querySelector('[data-review-next]');
    if (!track || cards.length < 2 || !previous || !next) return;
    let page = 0;
    let mobileMode = window.matchMedia('(max-width: 749px)').matches;
    const viewport = carousel.querySelector('.h2l-letter-reviews__viewport');
    const perPage = () => Math.max(1, Math.floor((viewport.clientWidth + 14) / (cards[0].getBoundingClientRect().width + 14)));
    const pageCount = () => Math.ceil(cards.length / perPage());
    const update = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const changedMode = mobile !== mobileMode;
      mobileMode = mobile;
      if (changedMode) page = 0;
      if (mobile) {
        track.style.transform = '';
        if (changedMode) requestAnimationFrame(() => { viewport.scrollLeft = 0; });
        return;
      }
      if (changedMode) viewport.scrollLeft = 0;
      page = Math.min(page, pageCount() - 1);
      previous.disabled = next.disabled = pageCount() < 2;
      const target = cards[Math.min(page * perPage(), cards.length - 1)];
      const offset = Math.min(target.offsetLeft - cards[0].offsetLeft, Math.max(0, track.scrollWidth - viewport.clientWidth));
      track.style.transform = `translateX(-${offset}px)`;
    };
    previous.addEventListener('click', () => {
      page = (page - 1 + pageCount()) % pageCount();
      update();
    });
    next.addEventListener('click', () => {
      page = (page + 1) % pageCount();
      update();
    });
    window.addEventListener('resize', update, { passive: true });
    const observer = new ResizeObserver(update);
    observer.observe(viewport);
    carousel.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      observer.disconnect();
      window.removeEventListener('resize', update);
    }, { once: true });
    update();
  };
  const initialiseAll = () => document.querySelectorAll('[data-h2l-review-carousel]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll);
  else initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
